import { Component, OnInit, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from "@angular/router";
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { FuseConfigService } from '../../../../../../core/services/config.service';
import { fuseAnimations } from '../../../../../../core/animations';
import { FuseNavigationModel } from '../../../../../../navigation/navigation.model';
import { FuseNavigationService } from '../../../../../../core/components/navigation/navigation.service';
import { FuseTranslationLoaderService } from '../../../../../../core/services/translation-loader.service';
import { locale as navigationEnglish } from '../../../../../../navigation/i18n/en';
import { locale as navigationTurkish } from '../../../../../../navigation/i18n/tr';

//Local file
import { register, toastMsg, roles, spekwo } from '../../../utils/index';

//Query files
import { UserQueryService, RolesQueryService } from '../../../queryFiles/index';

/** Service file */
import { AuthService } from '../../auth.service';

/** Local component */
import { ToastComponent } from '../../../common/toast.component';

@Component({
    selector: 'register-form',
    templateUrl: './register-from.component.html',
    styleUrls: ['./register-from.component.scss'],
    animations: fuseAnimations
})

export class RegisterationFormComponent implements OnInit {

    registerValues = register;
    toastMsg = toastMsg;
    roles = roles;
    spekwoValues = spekwo;

    registerForm: FormGroup;

    registerFormErrors: any;
    userUID: any;
    action: any;
    allEmails: Array<any> = [];

    isResults: boolean = false;
    enableClose: boolean = false;

    isEmailExist: string = ' ';
    registerSubscription: Subscription;
    allEmailSubscription: Subscription;

    constructor(
        private fuseConfig: FuseConfigService,
        private formBuilder: FormBuilder,
        private router: Router,
        private fuseNavigationService: FuseNavigationService,
        private translate: TranslateService,
        private translationLoader: FuseTranslationLoaderService,

        /** Local component */
        public toastComponent: ToastComponent,

        /**Query service */
        public userQueryService: UserQueryService,
        public rolesQueryService: RolesQueryService,

        /** Service file */
        public authService: AuthService
    ) {

        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar: 'none',
                footer: 'none'
            }
        });
        //Registration form errors
        this.registerFormErrors = {
            firstName: {},
            lastName: {},
            email: {},
            password: {},
            passwordConfirm: {},
            phoneNumber: {},
            address: {},
            userRole: {}
        };
        // Add languages
        this.translate.addLangs(['en', 'tr']);

        // Set the default language
        this.translate.setDefaultLang('en');

        // Use a language
        this.translate.use('en');
        this.translationLoader.loadTranslations(navigationEnglish, navigationTurkish);

        this.allEmailSubscription = this.userQueryService.GET_ALL_USERS_EMAIL()
            .subscribe(res => {
                let responseData = res && res.data && res.data.allUsers.edges;
                if (res.data.allUsers.edges.length > 0) {
                    responseData.forEach(element => {
                        this.allEmails.push({ email: element.node.email });
                    });
                }
            })

    }

    ngOnInit() {
        //Form controls
        this.registerForm = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            email: ['', [Validators.required, Validators.email, duplicateEmail(this.allEmails)]],
            password: ['', Validators.required],
            passwordConfirm: ['', [Validators.required, confirmPassword]],
            phoneNumber: ['', Validators.required],
            address: ['', Validators.required],
            userRole: ['', Validators.required],
            accept: ['', Validators.required]
        });

        this.registerForm.valueChanges.subscribe(() => {
            this.onRegisterFormValuesChanged();
        });
    }
    ngOnDestroy() {
        this.registerSubscription && this.registerSubscription.unsubscribe();
        this.allEmailSubscription && this.allEmailSubscription.unsubscribe();
    }

    //On change of form controls
    onRegisterFormValuesChanged() {

        for (const field in this.registerFormErrors) {

            if (!this.registerFormErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.registerFormErrors[field] = {};

            // Get the control
            const control = this.registerForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.registerFormErrors[field] = control.errors;
            }
        }

    }

    check() {

        var email = this.registerForm.get('email').value;
        var matched = _.find(this.allEmails, function (o) {
            return o.email.toLowerCase() === email.toLowerCase()
        });

        if (matched !== undefined) {
            this.isEmailExist = 'yes';
        }
        else {
            this.isEmailExist = 'no';
        }

    }

    //Registration
    doRegistration() {

        this.isResults = true;

        //1.call function to get Role Id of selected role
        this.authService.getRoleId(this.registerForm.value.userRole)
            .then(roleId => {

                //2.Save details
                this.registerSubscription = this.userQueryService.REGISTRATION(this.registerForm.value, roleId, '')
                    .subscribe(response => {

                        this.showToast('success');

                        window.localStorage.setItem("userUID", response.data.createUser.user.userId);
                        window.localStorage.setItem("role", this.registerForm.value.userRole);
                        // Set the navigation model
                        this.fuseNavigationService.setNavigationModel(new FuseNavigationModel());

                        setTimeout(() => {
                            this.router.navigate(['apps/e-commerce/orders']);
                        }, 10);


                    }, () => {
                        this.showToast('failed');

                    })
            })
            .catch(() => {
                this.showToast('failed');
            })

    }

    //Show toast message
    showToast(message) {

        this.toastComponent.showToast(message == 'success' ?
            this.toastMsg.registerSuccess :
            this.toastMsg.registerFailed);
        this.isResults = false;

    }
}

function confirmPassword(control: AbstractControl) {

    if (!control.parent || !control) {
        return;
    }

    const password = control.parent.get('password');
    const passwordConfirm = control.parent.get('passwordConfirm');

    if (!password || !passwordConfirm) {
        return;
    }

    if (passwordConfirm.value === '') {
        return;
    }

    if (password.value !== passwordConfirm.value) {
        return {
            passwordsNotMatch: true
        };
    }
}

function duplicateEmail(mails: any) {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

        if (!control.parent || !control) {
            return;
        }

        var matched = _.find(mails, function (o) {
            return o.email.toLowerCase() === control.value.toLowerCase()
        });

        if (matched !== undefined) {
            return { emailExist: true };
        }
        return null;
    };

}



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/authentication/registration/register-form/register-form.component.ts